import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isInvalidDate } from "../HelperFx/common";
import "./standardCard.css";

const StandardPageExpress = ({
  title,
  initialData = {},
  fields,
  actions = [],
  onChange: pageOnChange,
  onBlur: pageOnBlur = 0,
  redirectTo,
}) => {
  const [formData, setFormData] = useState(initialData);
  const [attachments, setAttachments] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (typeof pageOnChange === "function") {
      pageOnChange(field, value, formData);
    }
  };

  const handleBlur = (field, value) => {
    if (value === undefined || value === null) return;
    if (initialData[field] === value) return;

    const nextData = { ...formData, [field]: value };
    setFormData(nextData);
    if (typeof pageOnBlur === "function") {
      pageOnBlur(field, value, nextData);
    }
  };

  const handleFileUpload = (e, fieldName) => {
    const files = Array.from(e.target.files);
    if (fieldName) {
      setFormData({ ...formData, [fieldName]: files });
    } else {
      setAttachments([...attachments, ...files]);
    }
  };

  const renderField = (field) => {
    const value = formData[field.name] || "";

    switch (field.type) {
      case "textarea":
        return (
          <textarea
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            style={styles.input}
          />
        );
      case "select":
        return (
          <select
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            style={styles.input}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            disabled={field.disabled}
          >
            <option value=""></option>
            {field.options?.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        );
      case "checkbox":
        return (
          <input
            type="checkbox"
            checked={Boolean(formData[field.name])}
            onChange={(e) => {
              handleChange(field.name, e.target.checked);
              handleBlur(field.name, e.target.checked);
            }}
            disabled={field.disabled}
          />
        );
      case "datetime":
        return (
          <input
            type="datetime-local"
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            style={styles.input}
            disabled={field.disabled}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
          />
        );
      case "radio":
        return (
          <div style={{ display: "flex", gap: "12px" }}>
            {field.options?.map((opt, i) => (
              <label key={i}>
                <input
                  type="radio"
                  name={field.name}
                  value={opt.value}
                  checked={value === opt.value}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  disabled={field.disabled}
                  onBlur={(e) => handleBlur(field.name, e.target.value)}
                />
                {opt.label}
              </label>
            ))}
          </div>
        );
      case "file":
        return (
          <input
            type="file"
            multiple={field.multiple}
            onChange={(e) => handleFileUpload(e, field.name)}
            disabled={field.disabled}
          />
        );
      case "date": {
        const safeDate = !value || isInvalidDate(value) ? "" : value;
        return (
          <input
            type="date"
            value={safeDate}
            onChange={(e) => handleChange(field.name, e.target.value)}
            style={styles.input}
            disabled={field.disabled}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            onFocus={(e) => {
              if (!e.target.value || isInvalidDate(e.target.value)) {
                const today = new Date();
                const todayStr = today.toISOString().split("T")[0];
                handleChange(field.name, todayStr);
              }
            }}
          />
        );
      }

      default:
        return (
          <input
            type={field.type || "text"}
            value={value}
            onChange={(e) => handleChange(field.name, e.target.value)}
            onBlur={(e) => handleBlur(field.name, e.target.value)}
            style={styles.input}
            disabled={field.disabled}
            autoComplete={field.type === "password" ? "new-password" : "off"}
          />
        );
    }
  };

  return (
    <div className="express-card-page">
      <div
        style={{
          padding: "20px",
          paddingBottom: "20px",
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
          backgroundColor: "white",
        }}
      >
        <h2
          style={{
            paddingTop: "10px",
            paddingLeft: "20px",
            background: "white",
          }}
        >
          {title}
        </h2>

        <button
          type="button"
          onClick={() => navigate(`/${redirectTo}`)}
          style={styles.button}
        >
          Back
        </button>
        {actions.map((action, i) => (
          <button
            key={i}
            type="button"
            onClick={action.fx}
            style={{
              ...styles.button,
              display: action.visible === false ? "none" : "inline-flex",
              backgroundColor: action.color || "none",
            }}
          >
            {action.icon && (
              <span style={{ marginRight: "6px" }}>{action.icon}</span>
            )}
            {action.name}
          </button>
        ))}
      </div>
      <div className="form-layout-express">
        <form
          className="form-grid-express"
          onSubmit={(e) => e.preventDefault()}
          style={{ backgroundColor: "white" }}
        >
          {fields.map((field) => (
            <div key={field.name} className="form-field">
              <label style={styles.label}>{field.label}</label>
              {renderField(field)}
            </div>
          ))}
        </form>
      </div>
    </div>
  );
};

const styles = {
  label: { display: "block", fontWeight: "bold", marginBottom: "4px" },
  input: {
    width: "100%",
    padding: "6px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "8px 14px",
    border: "1.25px solid maroon",
    borderRadius: "4px",
    color: "grey",
    cursor: "pointer",
  },
};

export default StandardPageExpress;
